"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiService = void 0;
var date_helper_const_1 = require("@const/date-helper.const");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var fitpos_api_1 = require("../../../api/fitpos-api");
var magicline_api_1 = require("../../../api/magicline-api");
var backend_services_1 = require("@src/services/backend-services");
var OpenApiService = /** @class */ (function () {
    function OpenApiService() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.magiclineApi = object_service_1.ObjectService.getInstance(magicline_api_1.MagiclineApi);
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
    }
    OpenApiService.prototype.cancelContractExtraordinary = function (token, customer, contract) {
        return __awaiter(this, void 0, void 0, function () {
            var reasons, body, resp, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fitposAPI.getCancellationReasons(customer.id)];
                    case 1:
                        reasons = _a.sent();
                        if ((reasons === null || reasons === void 0 ? void 0 : reasons.length) === 0) {
                            return [2 /*return*/];
                        }
                        body = {
                            firstname: customer.firstName,
                            lastname: customer.lastName,
                            dateOfBirth: customer.dateOfBirth,
                            customerNumber: customer.customerNumber,
                            contractId: contract.id,
                            cancellationType: 'EXTRAORDINARY_CANCELLATION',
                            cancelationReasonId: reasons[0].cancelationReasonId,
                            cancellationDate: (0, date_helper_const_1._GetUserLocalTime)().toISOString().replace(/T.*/, ''),
                            additionalInformation: 'CUSTOMER DID UPGRADE PLEASE REMOVE OLD CONTRACT!!',
                            confirmationEmail: customer.email,
                        };
                        console.log('CUSTOMER NUMBER CANCEL EXTRAIRDOINARY', customer, contract, body);
                        return [4 /*yield*/, (0, backend_services_1.betterFetch)("https://".concat(this.config.get.tenantKey, ".api.magicline.com/connect/v1/contracts/cancel?recaptchaToken=").concat(token), {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify(body),
                            })];
                    case 2:
                        resp = _a.sent();
                        return [4 /*yield*/, resp.json()];
                    case 3:
                        data = _a.sent();
                        console.log(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    OpenApiService.prototype.createNewContract = function (customer, studioId, contract) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.magiclineApi.createNewCustomer({
                            tenantKey: '',
                            customer: __assign(__assign({}, customer), { firstname: customer.firstName, lastname: customer.lastName, telephone_mobile: customer.phonePrivate, paymentChoice: 'DIRECT_DEBIT', bankAccount: customer.bankAccount }),
                            studioId: +studioId,
                            contract: __assign({}, contract),
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return OpenApiService;
}());
exports.OpenApiService = OpenApiService;
